import React, { memo, useState } from "react";
import "./RouletteBettingBoardMobile.scss";
import CircleGridMobile from "./CircleGridMobile";
import UnderOverCardMobile from "./card/UnderOverCardMobile";
import ColorCardMobile from "./card/ColorCardMobile";
import RangeCardMobile from "./card/RangeCardMobile";

const TAB_BET_TYPE = "BET_TYPE";
const TAB_NUMBERS = "NUMBERS";

const RouletteBettingBoardMobile = (props) => {
    const { t, config, onBetting } = props;
    const rouletteBetTypes = config?.rouletteBetTypes;
    const [activeTab, setActiveTab] = useState(TAB_BET_TYPE);

    if (!rouletteBetTypes) return null;

    const {
        underOverOddEven = [],
        colors = [],
        numbers = [],
        range = [],
    } = rouletteBetTypes;

    return (
        <div className="rbm-board">
            <div className="rbm-board__tabs">
                <button
                    type="button"
                    className={`rbm-board__tab ${
                        activeTab === TAB_BET_TYPE ? "rbm-board__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab(TAB_BET_TYPE)}
                >
                    {t("labels:common.betType")}
                </button>

                <button
                    type="button"
                    className={`rbm-board__tab ${
                        activeTab === TAB_NUMBERS ? "rbm-board__tab--active" : ""
                    }`}
                    onClick={() => setActiveTab(TAB_NUMBERS)}
                >
                    លេខ 1-36
                </button>
            </div>

            <div className="rbm-board__content">
                {activeTab === TAB_BET_TYPE && (
                    <div className="rbm-board__bet-type">
                        <div className="rbm-board__bet-cards">
                            {underOverOddEven.map((item, index) => (
                                <UnderOverCardMobile
                                    key={item?.code || item?.name || index}
                                    t={t}
                                    item={item}
                                    {...props}
                                />
                            ))}
                        </div>

                        <div className="rbm-board__color-cards">
                            {colors.map((color, index) => (
                                <ColorCardMobile
                                    key={color?.code || color?.name || index}
                                    color={color}
                                    {...props}
                                />
                            ))}
                        </div>

                        <div className="rbm-board__range-cards">
                            {range.map((item, index) => (
                                <RangeCardMobile
                                    key={item?.code || item?.name || index}
                                    item={item}
                                    {...props}
                                />
                            ))}
                        </div>
                    </div>
                )}

                {activeTab === TAB_NUMBERS && (
                    <div className="rbm-board__numbers">
                        <CircleGridMobile numbers={numbers} onBetting={onBetting} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default memo(RouletteBettingBoardMobile);